import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useUser } from '../auth'
import { getTtiMe } from '../lib/api'

export default function StaffRoute ({ children }) {
  const user = useUser()
  const [permission, setPermission] = useState(null)

  useEffect(() => {
    let cancelled = false
    setPermission(null)
    if (user) {
      getTtiMe().then((data) => {
        if (!cancelled) setPermission({ user, allowed: Boolean(data.is_staff || data.is_superuser) })
      }).catch(() => {
        if (!cancelled) setPermission({ user, allowed: false })
      })
    }
    return () => { cancelled = true }
  }, [user])

  if (!permission || permission.user !== user) return <main><p>Loading...</p></main>
  return permission.allowed ? children : <Navigate to='/projects' replace />
}
